var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgMenuIconPartner = function SvgMenuIconPartner(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 60 61",
    "aria-hidden": true,
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30.143,
    r: 30,
    fill: "#EFE9FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2 30.143c2.288 0 4.2-1.842 4.2-4.125 0-2.247-1.912-4.125-4.2-4.125-2.325 0-4.2 1.878-4.2 4.125 0 2.283 1.875 4.125 4.2 4.125Zm2.85 1.178h-.3c-.788.368-1.65.59-2.55.59-.938 0-1.8-.222-2.587-.59h-.3c-2.4 0-4.313 1.915-4.313 4.272v1.032c0 .994.788 1.768 1.8 1.768h10.8c.975 0 1.8-.774 1.8-1.768v-1.032c0-2.357-1.95-4.272-4.35-4.272ZM36 30.143c1.987 0 3.6-1.584 3.6-3.536S37.987 23.07 36 23.07s-3.6 1.584-3.6 3.536 1.613 3.536 3.6 3.536Zm1.8 1.178h-.15a5.018 5.018 0 0 1-1.65.295c-.6 0-1.163-.11-1.688-.295H34.2c-.788 0-1.5.221-2.1.59.9.957 1.5 2.246 1.5 3.682v1.4c0 .074-.038.147-.038.221H40.2c.975 0 1.8-.773 1.8-1.768 0-2.246-1.913-4.125-4.2-4.125Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMenuIconPartner);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;